var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',[_c('v-row',{staticClass:"d-flex justify-center"},[_c('v-col',{attrs:{"cols":"12","sm":"11","md":"9","lg":"8"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('privacy.policy'))}})])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }